import config from "../config/config";
import { getToken } from "../utils/prefix"


  export async function visitor_create(data) {
    const res = await fetch(config.api_backend + `/visitor/create`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
  
  export async function get_all_visitor(data) {
    const res = await fetch(config.api_backend + `/visitor/all`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

  export async function get_count_visitor(data) {
    const res = await fetch(config.api_backend + `/visitor/count`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

 